import { registerComponent } from '@gig/magic-common';
import TermsUpdatedPrompterComponent from './terms-updated-prompter.js';

var TermsUpdatedPrompter = registerComponent(TermsUpdatedPrompterComponent);

export { TermsUpdatedPrompter };
